import React, { lazy, Suspense } from "react";

import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw, { styled } from "twin.macro";
import { css } from "@emotion/react";

import InstagramCard from "./InstagramCard";
import { withInstagram } from "./withInstagram";

import { Container, Link } from "@bared/ui";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);
SwiperCore.use([Pagination]);

const StyledSwiper = styled(Swiper)`
  ${css`
    .swiper-initialized {
      ${tw`pb-mega`}
    }
  `}
`;

const Instagram = withInstagram(({ contents }) => {
  return (
    <Container flush={true} data-component-type="section-instagram">
      {contents ? (
        <div>
          <Suspense fallback={<></>}>
            <StyledSwiper
              pagination={{ clickable: true }}
              slidesPerView={2.5}
              preloadImages={false}
              observer={true}
              observeParents={true}
              breakpoints={{
                1024: {
                  observer: true,
                  observeParents: true,
                  slidesPerView: 3.5,
                },
                1281: {
                  observer: true,
                  observeParents: true,
                  slidesPerView: 4.5,
                },
              }}
            >
              {contents?.map((content, index) => (
                <SwiperSlide key={index}>
                  <InstagramCard
                    productHandle={content?.productHandle}
                    postImage={content?.postImage}
                    instagramHandle={content?.userName}
                  />
                </SwiperSlide>
              ))}
            </StyledSwiper>
          </Suspense>
        </div>
      ) : null}
    </Container>
  );
});

export default Instagram;
